






































































































































































import moment from 'moment';
import * as R from 'ramda';
import Vue from 'vue';

import { Task } from '@/core/entity';

import AuditorButton from './Auditor.vue';
import RemarkInput from './Remark.vue';

import { listTaskQL } from './graphql';

export default Vue.extend({
  components: {
    'button-auditor': AuditorButton,
    'input-remark': RemarkInput,
  },

  apollo: {
    tasks: {
      query: listTaskQL,
      fetchPolicy: 'network-only',
    },
  },

  data() {
    return {
      tasks: [] as Task[],
    };
  },

  filters: {
    as_date(value: string) {
      return moment(parseInt(value, 10)).format('YYYY-MM-DD');
    },
  },

  methods: {
    onAssignAuditor(args: { taskId: string; userId: string | null }) {
      this.$emit('assign-auditor', args);
    },

    onUpdateNote(args: { taskId: string; value: string }) {
      this.$emit('update-note', { taskId: args.taskId, note: args.value });
    },
  },
});
